export const RIMS_LOCAL_STG_CONSTANTS = {
  LOGIN_TOKEN: "LOGIN_TOKEN",
  USER_INFO: "USER_INFO",
  MENU_AUTH_LIST: "MENU_AUTH_LIST",
  DATA_AUTH_LIST: "DATA_AUTH_LIST",
  SESSION_TIME_OUT: "SESSION_TIME_OUT",
  PRIVILEGES: "PRIVILEGES",
  DATEFORMAT: "DATEFORMAT",
  EMAIL: "EMAIL",
  DISABLE_BACK_PREVIOUS: "DISABLE_BACK_PREVIOUS",
  GLOBAL_LOADING: "GLOBAL_LOADING",
};

export const RIMS_COOKIE_CONSTANTS = {
  USER_TENANT_ID: "USER_TENANT_ID",
  LOGIN_TOKEN: "ACCESS_TOKEN",
  USER_ID: "USER_ID",
  URL_DOMAIN: "URL_DOMAIN",
  DOMAIN: "DOMAIN",
  USER_NAME: "USER_NAME",
  USER_EMAIL: "USER_EMAIL",
  USER_PRIVILEGES: "USER_PRIVILEGES",
  USER_INFO: "USER_INFO",
  AC_TENANT_ID: 'AC_TENANT_ID'
};

export const DEFAULT_LANGUAGE = 'en';

export const VALID_LANGUAGES = ['en', 'jp'];

export const LANGUAGEMAP: { [key: string]: any } = {
  mui: {
    en: "enUS",
    jp: "jaJP",
  },
};

export const enum ModeEnum {
  READ = "read",
  UPDATE = "update",
  CREATE = "create",
}
